var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOctagonCheckLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#686569",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.23 7.913 4.68-4.683c.15-.15.35-.23.57-.23h7.05c.21 0 .42.08.57.23l4.67 4.673c.15.15.23.35.23.57v7.054c0 .21-.08.42-.23.57l-4.67 4.673c-.15.15-.35.23-.57.23h-7.06a.81.81 0 0 1 -.57-.23l-4.67-4.673a.793.793 0 0 1 -.23-.57v-7.054c0-.21.08-.42.23-.57z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 13 3 3 5-7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctagonCheckLine);
export default __webpack_public_path__ + "static/media/octagon-check-line.9d0b7f42421d571528417bb5b48b3929.svg";
export { ForwardRef as ReactComponent };